import React from 'react';
import { Feature } from 'src/utils/feature-flags';
import { FormField } from 'src/view/components/form';

export const AdditionalLeadCaptureEmail = (props) => (
  <Feature name='rex_integration_lead_preference' invert>
    <FormField {...props} />
  </Feature>
);
